export default __webpack_public_path__ + "static/media/380.95affce8.gif";